import React from 'react';
import { Icon, Modal } from 'semantic-ui-react';
import styled from '@emotion/styled';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const CloseButton = styled.button`
  align-self: flex-end;
  background: transparent;
  border: 0;
  color: #444;
  cursor: pointer;
  padding: 15px;
`;

const ModalBody = styled.div`
  padding: 0 35px;
`;

const ModalHeader = styled.div`
  color: #4d4e4d;
  font-family: Lato;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
`;

const ModalInfo = styled.div`
  color: #4d4e4d;
  font-family: Lato;
  font-size: 16px;
  line-height: 24px;
  margin-top: 24px;
  min-height: 48px;
  white-space: pre-wrap;
  width: 320px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 9px;
  justify-content: center;
  margin-top: 45px;
`;

const BaseButton = styled.button`
  border-radius: 5px;
  box-sizing: border-box;
  cursor: pointer;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  height: 47px;
  line-height: 21px;
  padding: 0 12px;
  text-align: center;
  width: 160px;
`;

const SecondaryButton = styled(BaseButton)`
  background: #444;
  border: 1px solid #333;
  color: #fff;
`;

const PrimaryButton = styled(BaseButton)`
  background: #ff5252;
  border: 1px solid #ff5252;
  color: #fff;
`;

interface Props {
  open: boolean;
  onClose: () => void;
  onCompress: () => void;
  onContinueWithoutCompressing: () => void;
}

const LargePdfCompressionPromptModal = (props: Props) => (
  <Modal
    open={props.open}
    onClose={props.onClose}
    closeOnDimmerClick={false}
    style={{ height: 310, width: 393 }}
  >
    <ModalContent>
      <CloseButton type="button" onClick={props.onClose} aria-label="Close">
        <Icon name="close" />
      </CloseButton>
      <ModalBody>
        <ModalHeader>Large PDF Detected!</ModalHeader>
        <ModalInfo>
          One or more selected PDFs are 15 MB or larger. Would you like to try compressing them before
          sending?
        </ModalInfo>
        <ButtonContainer>
          <SecondaryButton type="button" onClick={props.onContinueWithoutCompressing}>
            Continue Without Compressing
          </SecondaryButton>
          <PrimaryButton type="button" onClick={props.onCompress}>
            Try Compressing
          </PrimaryButton>
        </ButtonContainer>
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default LargePdfCompressionPromptModal;
